import React, { useContext, useEffect, useState } from "react";
import styles from "./Dashboard.module.css";
import SideControl from "../../components/SideControl";
import Home from "./Home";
import MapPage from "../MapPage";
import DashboardContext from "../../context/DashboardContext";
import { Outlet, useLocation } from "react-router-dom";
import ErrorBoundary from "../../errorHandler/ErrorBoundary";

const Dashboard = ({tabIndex}) => {
    const { controlTabIndex, setControlTabIndex } =
        useContext(DashboardContext);
    const location = useLocation();
    const pathname = location.pathname;

    useEffect(() => {
        // if (localStorage.getItem("cIndex")) {
        //     setControlTabIndex(parseInt(localStorage.getItem("cIndex")));
        // } else {
        //     setControlTabIndex(0);
        // }
        setControlTabIndex(tabIndex)
    }, []);

    return (
        <>
            <div className={"sideControlContainer"}>
                <SideControl
                    controlTabIndex={controlTabIndex}
                    setControlTabIndex={setControlTabIndex}
                />
            </div>
            <div
                className={`${"projectsContainer"} hideScrollbar smooth-scroll ${
                    pathname.includes("cmaps") ? "cmapsContainer" : ""
                }`}
            >
                <ErrorBoundary>
                    <Outlet />
                </ErrorBoundary>
            </div>
        </>
    );
};

export default Dashboard;
